<template>
    <div class="backConfig chartConfig_viewDP">
        <div class="chartDivConfig selViewConfig minInput">
            <span class="span_til">背景</span>
            <el-select v-model="back.index" placeholder="请选择背景"
                       :popper-append-to-body="false" class="el-popper-back">
                <el-option :label="'背景'+(index+1)" :value="index" v-for="(item,index) in list">
                    <img :src="`${configImgUrl()}${item.img}`" alt="">
                    <span>{{'背景'+(index+1)}}</span>
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">遮罩颜色</span>
            <el-color-picker v-model="back.modalBackColor" show-alpha></el-color-picker>
        </div>
    </div>
</template>

<script>
    import {backList} from '../../script/comChart'

    /**
     @author xiaoye
     @date 2020/5/17 7:37 下午
     */
    export default {
        name: 'backConfig',
        components: {},
        props: {},
        data() {
            return {
                list: backList
            }
        },
        computed: {
            back() {
                return this.$store.state.designer.nowChart.pageParam.back;
            },
        },
        methods: {},
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .backConfig {
        .minInput {
            > span {
                max-width: 40px !important;
            }

            .el-popper-back {
                .el-popper {
                    width: 220px;
                    .el-scrollbar{
                        .el-scrollbar__wrap{
                            padding: 8px;
                            height: 100%;
                            margin-right: 0 !important;
                            >ul{
                                >li{
                                    height: 60px;
                                    width: calc(50% - 2px);
                                    line-height: 60px;
                                    padding: 2px;
                                    margin: 0;
                                    display: inline-block;
                                    vertical-align: top;
                                    position: relative;
                                    text-align: center;
                                    >span{
                                        position: absolute;
                                        bottom: 5%;
                                        left: 5%;
                                        line-height: 20px;
                                    }
                                    >img{
                                        height: 55px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .el-select {
                width: 50% !important;
            }
        }

    }
</style>
